import { createEntityCollectionStore } from '@recruitee/ngrx';

import { Source } from '../../../types';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<Source>()('Source', {
  idSelector: (entity: { compoundId: string }) => entity.compoundId,
});

export {
  actions as SourceActions,
  namespace as SourceNamespace,
  reducer as SourceReducer,
  selectors as SourceSelectors,
};
